import {createSlice} from '@reduxjs/toolkit'
import {setThresholds} from "./imageSlice";

const appSlice = createSlice({
    name: 'app',
    initialState: {
        liveUpdate: true,
        slidersLocked: true,
    },
    reducers: {
        toggleLiveUpdate: (state, action) => { state.liveUpdate = !state.liveUpdate },
        setLiveUpdate: (state, action) => {
            state.liveUpdate = action.payload;
        },
        setSlidersLockedSuccess: (state, action) => {
            state.slidersLocked = action.payload;
        },
    },
})


//export const toggleLiveUpdate = () => async (dispatch, getState) => {
//    dispatch(toggleLiveUpdateSuccess())
//    //dispatch(setLiveUpdate(!getState().app.liveUpdate))
//}

export const toggleSlidersLocked = () => async (dispatch, getState) => {
    const newValue = !getState().app.slidersLocked;
    dispatch(setSlidersLockedSuccess(newValue))
    if (newValue) {
        const threshold = getState().image.thresholds.red;
        dispatch(setThresholds({
            red: threshold,
            green: threshold,
            blue: threshold,
        }))
    }
}


export const {
    setLiveUpdate,
    setSlidersLockedSuccess,
    toggleLiveUpdate,

} = appSlice.actions;

export default appSlice.reducer
